import { SignIn } from "@clerk/tanstack-react-start";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { WorkEmailFormGuard } from "@/components/auth/work-email-guard";
import { useRedirectAfterAuth } from "@/hooks/use-redirect-after-auth";

export const Route = createFileRoute("/sign-in/$")({
  beforeLoad: async ({ context }) => {
    if (context.userId) {
      throw redirect({ to: "/app" });
    }
  },
  component: SignInCatchAll,
});

function SignInCatchAll() {
  useRedirectAfterAuth();

  return (
    <div className="flex flex-1 items-center justify-center px-4">
      <WorkEmailFormGuard>
        <SignIn routing="path" path="/sign-in" signUpUrl="/create" fallbackRedirectUrl="/app" />
      </WorkEmailFormGuard>
    </div>
  );
}
